/* src/app/components/print-settings-labels/print-settings-labels.component.scss */
ion-icon {
  width: 18px;
  height: 18px;
}
ion-icon.small {
  width: 20px;
  height: 20px;
}
ion-icon.large {
  width: 25px;
  height: 25px;
}
ion-badge {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 14px;
  border-radius: 20px;
  margin-bottom: 0;
  background: #d4ecff;
  color: #259dff;
  padding: 5px 8px;
  cursor: default;
}
ion-badge.finishing {
  background: #fff0c6;
  color: #d59b00;
}
ion-badge.small {
  font-size: 12px;
  height: 20px;
  min-width: 35px !important;
}
ion-badge.large {
  font-size: 16px;
}
/*# sourceMappingURL=print-settings-labels.component-CVVKZ57Y.css.map */
